import type { ButtonGroupProps } from '../ButtonGroup';
import { ButtonGroup } from '../ButtonGroup';

export type StatesActionsProps = ButtonGroupProps;

const StatesActions = (props: StatesActionsProps) => <ButtonGroup {...props} />;

export default StatesActions;
